package app.view

import app.CustomRouter
import app.Routes
import app.api.RolloutExecutionApi
import app.components.sidebarNavigation
import app.utils.formatDateTime
import dev.fritz2.core.*

fun RenderContext.rolloutExecution(
    rolloutExecutionApi: RolloutExecutionApi,
    projectId: String?,
    rolloutId: String?,
) {
    if (projectId == null || rolloutId == null) {
        CustomRouter.navTo(mapOf("route" to Routes.PROJECTS))
        return
    }

    rolloutExecutionApi.handler(rolloutId)
    rolloutExecutionApi.data.renderNotNull { rolloutExecution ->
        div("flex gap-4 dark:text-white") {
            sidebarNavigation(projectId)
            div("basis-10/12 border rounded-md shadow-md my-4 p-4 dark:bg-gray-800 dark:border-gray-700") {
                div("flex justify-between mb-4 items-center") {
                    div("flex items-center space-x-2") {
                        button("hover:underline") {
                            +"Rollouts"
                            clicks handledBy {
                                CustomRouter.rollouts(
                                    mapOf(
                                        "route" to Routes.ROLLOUTS,
                                        Routes.Params.PROJECT_ID to projectId,
                                    )
                                )
                            }
                        }
                        div {
                            +"/"
                        }
                        div("font-semibold") {
                            +"${rolloutExecution.id}"
                        }
                    }
                }
                div("flex gap-2") {
                    div("font-semibold") {
                        +"Status:"
                    }
                    div {
                        +rolloutExecution.status
                    }
                }
                div("flex gap-2") {
                    div("font-semibold") {
                        +"Version:"
                    }
                    div {
                        +rolloutExecution.version.toString()
                    }
                }
                div("flex gap-2") {
                    div("font-semibold") {
                        +"Started at:"
                    }
                    div {
                        +formatDateTime(rolloutExecution.startedAt)
                    }
                }
                div("flex gap-2") {
                    div("font-semibold") {
                        +"Finished at:"
                    }
                    div {
                        +formatDateTime(rolloutExecution.finishedAt)
                    }
                }
                div("flex gap-2") {
                    div("font-semibold") {
                        +"Logs:"
                    }
                    div {
                        +rolloutExecution.logs
                    }
                }
            }
        }
    }
}
